import { module } from 'modujs';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);

        this.$sliderImages = this.$('sliderImages')[0];
        this.$sliderContent = this.$('sliderContent')[0];

        this.events = {
            click: {
                prev: 'prev',
                next: 'next'
            }
        }
    }

    init() {

        this.swiperImages = new Swiper(this.$sliderImages,{
            speed: 1000,
            // effect: 'fade',
            // creativeEffect: {
            //     prev: {
            //         translate: ['-100%',0,0],
            //         rotate: [0,0,-45]
            //     },
            //     next: {
            //         translate: ['100%',0,0],
            //         rotate: [0,0,45]
            //     }
            // }
        });

        this.swiperContent = new Swiper(this.$sliderContent,{
            speed: 1000,
            loop: false,
            effect: 'fade',
            touchable: false
        });

        this.oldIndex = -1;

        this.swiperImages.on('slideChange', (e) => {
            this.swiperContent.slideTo(e.activeIndex);
            // this.slideContentChange(e);
        });

        this.swiperContent.on('slideChange', (e) => {
            this.swiperImages.slideTo(e.activeIndex);
            this.slideContentChange(e);
        });

        this.slideContentChange(this.swiperContent);

    }

    prev() {
        this.swiperContent.slidePrev();
    }

    next() {
        this.swiperContent.slideNext();
    }

    slideContentChange(e) {
        
        let $slide = e.slides[e.activeIndex];
        let $lineActiveTitle = $slide.querySelectorAll('[data-module-split]');

        if(this.displayingDelay != undefined) {
            this.displayingDelay.kill();
        }

        this.displayingDelay = gsap.delayedCall(this.oldIndex != -1 ? 0.8 : 0, () => {

            $lineActiveTitle.forEach((item) => {
                // call animate
                this.call('animate',{},'Split',item.getAttribute('data-module-split'));
            });
        });


        if(this.oldIndex != -1) {
            let $oldSlide = e.slides[this.oldIndex];
            // call reverse
            
            let $lineOldTitle = $oldSlide.querySelectorAll('[data-module-split]');

            $lineOldTitle.forEach((item) => {
                // call animate
                this.call('reverse',{},'Split',item.getAttribute('data-module-split'));
            });

        }
        this.oldIndex = e.activeIndex;

        if(this.swiperContent.isEnd) {
            this.el.classList.add('is-end');
        } else {
            this.el.classList.remove('is-end');
        }

        if(this.swiperContent.isBeginning) {
            this.el.classList.add('is-beginning');
        } else {
            this.el.classList.remove('is-beginning');
        }
    }
}
